import orderConfirmationBannerDesktop from 'assets/images/checkout/prose-assortment-of-haircare-and-skincare-products-desktop.jpg';
import orderConfirmationBannerMobile from 'assets/images/checkout/prose-assortment-of-haircare-and-skincare-products-mobile.jpg';
import orderConfirmationBannerTablet from 'assets/images/checkout/prose-assortment-of-haircare-and-skincare-products-tablet.jpg';
import clinicalClaimsImg from 'assets/images/landingPages/skincare/skincare-lp-clinical-claims.jpg';

export const upsellBlock = {
  tracking: {
    pageView: 'Post Purchase Refer A Friend Offer Embedded Module - Viewed',
  },
  img: {
    desktop: orderConfirmationBannerDesktop,
    tablet: orderConfirmationBannerTablet,
    mobile: orderConfirmationBannerMobile,
  },
  title: {
    referFriends: (
      <span>Refer your friends to Prose with $20 off — and you’ll get $20 off too.</span>
    ),
  },
  cta: {
    referFriend: {
      label: 'Share Prose',
      url: '/account/refer-a-friend',
      dataTestId: 'go-to-refer',
      dataFrom: 'post-purchase-refer-a-friend-offer-embedded-module',
      dataClick: 'refer',
    },
  },
};

export const skincareMinisPromoVideo = {
  video: {
    poster: clinicalClaimsImg,
    videoSrc: 'video-promo-skincare',
    alt: 'Woman holding bottle of Prose custom cleanser',
  },
};
